// extracted by mini-css-extract-plugin
module.exports = {"colorAccent":"#45bded","socialLinks":"socialLinks_socialLinks__37694","socialLink":"socialLinks_socialLink__Qo0FD"};